import { render, staticRenderFns } from "./ModalConfigGeraisWebCheckout.vue?vue&type=template&id=720fe1be&scoped=true&"
import script from "./ModalConfigGeraisWebCheckout.vue?vue&type=script&lang=js&"
export * from "./ModalConfigGeraisWebCheckout.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfigGeraisWebCheckout.vue?vue&type=style&index=0&id=720fe1be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720fe1be",
  null
  
)

export default component.exports